export const merchandisingConfig = {
  merchandisingTier: {
    label: 'Merchandising Tier',
    isVisible: true,
    type: 'select',
    data: [
      { id: 'Luxury' },
      { id: 'Premium Plus' },
      { id: 'Premium' },
      { id: 'Core/Premium' },
      { id: 'Core' },
      { id: 'Value' },
      { id: 'Recently Open' },
      { id: 'HOOL' },
    ],
    allowClear: true,
  },
  totalFrameCapacity: {
    label: 'Total Frame Capacity',
    isVisible: true,
    inputType: 'number',
    min: 0,
    max: 9999,
    step: 1,
    rules: [
      {
        validator: (_: any, value: any) =>
          value == null ||
          value === '' ||
          (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 9999)
            ? Promise.resolve()
            : Promise.reject(new Error('Enter a whole number from 0 to 9999')),
      },
    ],
  },
  brandedFixtureCapacity: {
    label: 'Branded Fixture Capacity',
    isVisible: true,
    inputType: 'number',
    min: 0,
    max: 9999,
    step: 1,
    rules: [
      {
        validator: (_: any, value: any) =>
          value == null ||
          value === '' ||
          (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 9999)
            ? Promise.resolve()
            : Promise.reject(new Error('Enter a whole number from 0 to 9999')),
      },
    ],
  },
  genericFixtureCapacity: {
    label: 'Generic Fixture Capacity',
    isVisible: true,
    inputType: 'number',
    min: 0,
    max: 9999,
    step: 1,
    rules: [
      {
        validator: (_: any, value: any) =>
          value == null ||
          value === '' ||
          (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 9999)
            ? Promise.resolve()
            : Promise.reject(new Error('Enter a whole number from 0 to 9999')),
      },
    ],
  },
  frameCapacityGroup: {
    label: 'Frame Capacity Group',
    isVisible: true,
    type: 'select',
    allowClear: true,
    options: [
      { id: 'under700', value: 'Under 700' },
      { id: 'small', value: 'Small' },
      { id: 'medium', value: 'Medium' },
      { id: 'large', value: 'Large' },
      { id: 'largest1800Plus', value: 'Largest 1800+' },
    ],
  },
};
